/*
 * @Author: zfd
 * @Date: 2020-09-06 10:08:57
 * @LastEditTime: 2020-09-06 17:23:53
 * @Description: 
 * @FilePath: \trip-enterprise\src\api\account.js
 */
import axios from './index'
const role = '/co/role',
    sys = '/co/sys';

/**
 * 用户
 */

//分页
const getMembers = (param) => {
    return new Promise(resolve => {
        axios.post(sys + '/getMemberList', param).then(res => resolve(res))
    })
}
const addMember = (param) => {
    return new Promise(resolve => {
        axios.post(sys + '/AddMember', param).then(res => resolve(res))
    })
}
const updateMember = (param) => {
    return new Promise(resolve => {
        axios.post(sys + '/UpdateMember', param).then(res => resolve(res))
    })
}
const changeMemberState = (param) => {
    return new Promise(resolve => {
        axios.post(sys + '/ChangeMemberState', param).then(res => resolve(res))
    })
}
/**
 * 角色
 */
const getRoles = () => {
    return new Promise((resolve) => {
        axios.post(role + '/getRoles').then(res => {
            resolve(res)
        })
    });
}

const addRole = (param) => {
    return new Promise((resolve) => {
        axios.post(role + '/addRoles', param).then(res => {
            resolve(res)
        })
    });
}

const updateRole = (param) => {
    return new Promise((resolve, reject) => {
        axios.post(role + '/updateRole', param).then(res => {
            resolve(res)
        }).catch(err => reject(err));
    });
}

const deleteRole = (param) => {
    return new Promise((resolve) => {
        axios.post(role + '/deleteRole', param).then(res => {
            resolve(res)
        })
    });
}

const changeRoleState = (param) => {
    return new Promise((resolve) => {
        axios.post(role + '/changeRoleState', param).then(res => {
            resolve(res)
        })
    });
}

const getRoleMenus = (param) => {
    return new Promise((resolve) => {
        axios.get(role + '/GetRoleMenus?roleId=' + param).then(res => {
            resolve(res)
        })
    });
}
const getRoleMembers = (param) => {
    return new Promise((resolve) => {
        axios.get(role + '/GetRoleMembers?roleId=' + param).then(res => {
            resolve(res)
        })
    });
}
/**
 * 菜单
 */
const getMenu = (pid) => {
    return new Promise((resolve) => {
        axios.get(sys + '/getmenu?pid=' + pid).then(res => {
            resolve(res)
        })
    });
}


const addMenu = (param) => {
    return new Promise((resolve) => {
        axios.post(sys + '/addMenu', param).then(res => {
            resolve(res)
        })
    });
}

/**
 * 删 启用 禁用 编辑
 * @param {*} param 
 */
const changeMenu = (param) => {
    return new Promise((resolve) => {
        axios.post(sys + '/changeMenu', param).then(res => {
            resolve(res)
        })
    });
}

/**
 * 获取菜单树
 */
const getMenuTree = () => {
    return new Promise((resolve) => {
        axios.get(sys + '/getmenutree').then(res => {
            resolve(res)
        })
    });
}
/**
 * 附件
 */

const deleteAttachment = param => {
    return new Promise((resolve) => {
        axios.post('/co/attachment/ChangeAttachmentStatus', param).then(res => {
            resolve(res)
        })
    });
}
export default {
    getMembers,
    addMember,
    updateMember,
    changeMemberState,
    getRoles,
    addRole,
    updateRole,
    deleteRole,
    getRoleMenus,
    getRoleMembers,
    getMenu,
    addMenu,
    changeMenu,
    deleteAttachment,
    getMenuTree,
    changeRoleState
}